import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 mx-auto mt-8 text-center max-w-[600px]">
          <h2 className="mb-4 text-xl font-medium text-secondary">Something went wrong</h2>
          <p className="mb-4 text-secondary/70">
            We're sorry, but there was an error loading this component. Try refreshing the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 font-medium text-white transition-colors rounded-md bg-primary hover:bg-primary/90"
          >
            Refresh Page
          </button>
          {process.env.NODE_ENV === 'development' && (
            <details className="p-4 mt-4 text-left border rounded-md border-secondary/20">
              <summary className="mb-2 font-medium cursor-pointer text-secondary">Error Details</summary>
              <pre className="p-2 overflow-auto text-sm bg-gray-100 rounded">
                {this.state.error && this.state.error.toString()}
              </pre>
              <pre className="p-2 mt-2 overflow-auto text-sm bg-gray-100 rounded">
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 